<template>
  <v-container fluid class="mt-0 pt-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card outlined>
          <v-card-title>
            <v-btn icon class="mr-2" @click="goBack">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <h3>{{ integrationTitle }}</h3>
          </v-card-title>
          <v-card-text>
            <VivoGestaoAccessList v-if="slug === 'vivo_gestao'" />
            <div v-else class="text-center py-6 grey--text">
              Integração não disponível.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VivoGestaoAccessList from "./vivoGestao/VivoGestaoAccessList.vue";

export default {
  components: {
    VivoGestaoAccessList,
  },
  computed: {
    slug() {
      return this.$route.params.slug;
    },
    integrationTitle() {
      if (this.slug === "vivo_gestao") {
        return "Vivo Gestão";
      }

      return "Integração";
    },
  },
  methods: {
    goBack() {
      this.$router.push("/configuration_company/");
    },
  },
};
</script>
